import React from 'react';

import { LearningCertificateStyleProps } from '../../types';

export const LearningCertificateStyle: React.FC<LearningCertificateStyleProps> = () => {
    return <div />;
};
